import RestClient from './RestClient';
import { EquipmentOrder } from '../../models';
import store from '../../redux';
import { getApiErrorMessage } from './getApiErrorMessage';

class EquipmentOrders extends RestClient {
    constructor() {
        super({
            model: EquipmentOrder,
            entryPoint: 'equipment_order',
            resource: 'equipment_order',
            resources: 'equipment_orders',
            id_field: 'id'
        });
    }

    icsLink({ includeDrafts = false, lang } = {}) {
        const link = new URL(`${this.baseUrl}/equipment_order/ics`);
        const user = store.getState().auth.user;
        if (user?.api_key)
            link.searchParams.append('x-api-key', user.api_key);
        if (includeDrafts)
            link.searchParams.append('include_drafts', '1');
        if (lang)
            link.searchParams.append('lang', lang);

        return link.href;
    }

    planning() {
        return this.GET('/equipment_order/planning')
            .then(response => response.json())
            .then(json => {
                if (json.equipment_orders)
                    return {
                        equipment_orders: json.equipment_orders.map(order => new EquipmentOrder(order)),
                        editions: json.equipment_planning_editions || [],
                    };
                throw new Error(getApiErrorMessage(json));
            });
    }

    byEdition(editionId) {
        return this.GET(`/equipment_order/by_edition/edition_id/${editionId}`)
            .then(response => response.json())
            .then(json => {
                if (json.equipment_order)
                    return { equipment_order: new EquipmentOrder(json.equipment_order) };
                throw new Error(getApiErrorMessage(json));
            });
    }

    submit(id) {
        return this.POST(`/equipment_order/submit/id/${id}`, {})
            .then(response => response.json());
    }

    confirm(id) {
        return this.POST(`/equipment_order/confirm/id/${id}`, {})
            .then(response => response.json());
    }

    reopen(id) {
        return this.POST(`/equipment_order/reopen/id/${id}`, {})
            .then(response => response.json());
    }

    duplicate(id, targetEditionId) {
        return this.POST(`/equipment_order/duplicate/id/${id}`, {
            target_edition_id: targetEditionId
        }).then(response => response.json()).then(json => {
            if (json.equipment_order)
                return { equipment_order: new EquipmentOrder(json.equipment_order) };
            throw new Error(getApiErrorMessage(json));
        });
    }
}

const EquipmentOrdersApi = new EquipmentOrders();

export default EquipmentOrdersApi;
